import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { GbgIdentityVerificationStore, GbgIdentityVerificationState } from './gbg-identity-verification.store';

@Injectable({ providedIn: 'root' })
export class GbgIdentityVerificationQuery extends QueryEntity<GbgIdentityVerificationState> {

  constructor(protected store: GbgIdentityVerificationStore) {
    super(store);
  }

}
